import { render, staticRenderFns } from "./AmountTranslated.vue?vue&type=template&id=bf72b854&scoped=true&"
import script from "./AmountTranslated.vue?vue&type=script&lang=js&"
export * from "./AmountTranslated.vue?vue&type=script&lang=js&"
import style0 from "./AmountTranslated.vue?vue&type=style&index=0&id=bf72b854&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf72b854",
  null
  
)

export default component.exports